import { styled } from 'styled-components';

import { Button } from '@/shared/ui/button';
import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 32px;
    ${mq.lt.md} {
        justify-content: space-between;
        margin-bottom: 24px;
        padding: 0 12px;
        gap: 0;
    }
    ${mq.lt.sm} {
        margin-bottom: 0;
    }

    &.default {
        display: flex;
        gap: 32px;

        .left {
            flex: 1;
            max-width: 300px;
            ${mq.lt.lg} {
                width: 100%;
                max-width: 100%;
            }
            ${mq.lt.md} {
                display: none;
            }
        }

        .right {
            display: flex;
            gap: 32px;
            ${mq.lt.lg} {
                flex: 1;
                width: 100%;
                max-width: 100%;
            }
            ${mq.lt.md} {
                justify-content: space-between;
            }
        }

        button {
            &.btn-panel {
                padding: 0;
            }
            ${mq.lt.md} {
                padding: 0;
            }
        }
    }

    button {
        height: 44px;
        justify-content: flex-start;
        padding: 14px 16px;
        display: flex;
        font-size: 14px;
        gap: 8px;
        align-items: center;

        &.btn-reserve {
            ${mq.lt.md} {
                display: none;
            }
        }

        &.basket-btn {
            &.active {
                background: ${({ theme }) => theme.color.dark};
                color: ${({ theme }) => theme.color.secondary};
            }
        }

        &.fav-btn {
            background-color: ${({ theme }) => theme.color.secondary};
            border: none;
        }
    }
`;

export const ProductTextButton = styled(Button).attrs({
    fontSize: 'xs',
    variant: 'primary',
})`
    border-radius: 4px;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center !important;
    max-width: 300px;
    width: 100%;
    ${mq.lt.xl} {
        max-width: 285px;
    }
    ${mq.lt.lg} {
        max-width: 100%;
    }
    ${mq.lt.md} {
        max-width: 100%;
    }

    span {
        display: flex;
    }
`;
